module.exports = __webpack_public_path__ + "img/Z-Logo.c0307643.png";